module.exports = __webpack_public_path__ + "img/plus-solid.401fda71.svg";